import {
  TableMapping,
  tableMappingSchema,
} from "@made-people/centra-checkout-api";
import { ProductBase } from "@made-people/grease-product";
import { getTableMappingIdForCountryCode } from "../../../services/centra/mappers/utils/get-table-mapping-id-for-country-code";

export const getVariantStockDeliveryData = (
  productBase: ProductBase,
  countryCode: string,
): {
  discontinued: boolean;
  litWarehouseStatus: string | null;
  tableMapping: TableMapping;
} | null => {
  const tableMappings = productBase.attributes.find(
    (x) => x.attributeKey === "tableMappings",
  )?.value as Record<string, TableMapping>;

  if (!tableMappings) {
    return null;
  }

  const tableMappingId = getTableMappingIdForCountryCode(countryCode);
  const tableMapping = tableMappings?.[tableMappingId];
  const parsedTableMapping = tableMappingSchema.safeParse(tableMapping);

  if (parsedTableMapping.success === false) {
    return null;
  }
  // Get product-level warehouse status (contains JSON with all sizes)
  const productLitWarehouseStatus = productBase.attributes.find(
    (x) => x.attributeKey === "out_of_stock_message_lit_text",
  )?.value;

  // Get product-level discontinued status
  const productDiscontinuedBool = productBase.attributes.find(
    (x) => x.attributeKey === "discontinued_bool",
  )?.value;

  const discontinued =
    productDiscontinuedBool === "1" ||
    productDiscontinuedBool === "true" ||
    productDiscontinuedBool === true ||
    productBase.discontinued;

  const litWarehouseStatus =
    typeof productLitWarehouseStatus === "string"
      ? productLitWarehouseStatus
      : null;

  return {
    discontinued,
    litWarehouseStatus,
    tableMapping,
  };
};
